import { render } from "./mc.vue?vue&type=template&id=40591dc0&ts=true"
import script from "./mc.vue?vue&type=script&lang=ts"
export * from "./mc.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/mc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40591dc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40591dc0', __exports__)) {
    api.reload('40591dc0', __exports__)
  }
  
  module.hot.accept("./mc.vue?vue&type=template&id=40591dc0&ts=true", () => {
    api.rerender('40591dc0', render)
  })

}


export default __exports__